import { render } from "./ReportPage.vue?vue&type=template&id=61173784&ts=true"
import script from "./ReportPage.vue?vue&type=script&lang=ts"
export * from "./ReportPage.vue?vue&type=script&lang=ts"

import "./ReportPage.vue?vue&type=style&index=0&id=61173784&lang=scss"

import exportComponent from "/home/nathan/public_html/accident-plan/accident-plan-api-whitelabel/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__